
// ! Event Template



/*
import Made_To_Mingle from '../../assets/events/Made To Mingle.jpg';

{
    id: 1,
    title: `Made To Mingle`,
    img: Made_To_Mingle,
    description: `In this event, students have to make a power point presentation (ppt).2. Topics were given on the spot to the participants and time was given to them from 10 a.m. to 11:30 a.m 3. Topics of the competition were:-● On the occasion of International Yoga Day, which was on 21st June, 2021 we gave the topic as "The benefits of Yoga" ● On the occasion of Environment day which was on 5th June, 2021 we gave the topic as "Environment" All the participants have to make a ppt on either of one topic.`,
    guidelines: [
        'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Alias doloribus natus sapiente veniam culpa. Veritatis, distinctio.',
        'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Alias doloribus natus sapiente veniam culpa. Veritatis, distinctio.',
        'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Alias doloribus natus sapiente veniam culpa. Veritatis, distinctio.',
        'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Alias doloribus natus sapiente veniam culpa. Veritatis, distinctio.',
        'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Alias doloribus natus sapiente veniam culpa. Veritatis, distinctio.',
        'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Alias doloribus natus sapiente veniam culpa. Veritatis, distinctio.',
        'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Alias doloribus natus sapiente veniam culpa. Veritatis, distinctio.',
        'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Alias doloribus natus sapiente veniam culpa. Veritatis, distinctio.',
        'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Alias doloribus natus sapiente veniam culpa. Veritatis, distinctio.',
    ],
    formLink: 'https://forms.gle/963Qt8gYgsrZPQbE9',
    discordLink: 'https://discord.gg/f6vUxUKphU'
}
*/

export const activeEvents = [];
